var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6946 11.2688V14.2021C14.6946 14.5911 14.5401 14.9641 14.2651 15.2392C13.99 15.5142 13.617 15.6688 13.228 15.6688H2.9613C2.57231 15.6688 2.19926 15.5142 1.92421 15.2392C1.64915 14.9641 1.49463 14.5911 1.49463 14.2021V3.93542C1.49463 3.54643 1.64915 3.17338 1.92421 2.89833C2.19926 2.62327 2.57231 2.46875 2.9613 2.46875H5.89463",
    stroke: "#B8BBC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19502 11.12L16.1617 4.08L13.0817 1L6.11502 7.96668L5.89502 11.2667L9.19502 11.12Z",
    stroke: "#B8BBC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.634bd873b9b2c9318264170b96098e2f.svg";
export { ForwardRef as ReactComponent };